<template>
<div class="login-footer">
  <span>
    {{ $t('common.onycom') }}  
  </span>
</div>
</template>

<script>
/* 2021.04.13 - Nam Sang Woo
 * app-login-footer 컴포넌트 
 * description: 추후 공통적으로 쓰일 것으로 예상되어 만들어 놨습니다.
 */ 
export default {
	name: "appLoginFooter",
};
</script>

<style lang="scss" scoped>
.login-footer {
  position: absolute;
  bottom: 30px;
  color:#6E748F;
  color: #9d9d9d;
  font-size: 12px;
  font-weight: 400;
} 
</style>